import SeekerStore from "./seekerStore";
import { action, observable } from "mobx";
import Fetcher from "../utils/fetcher";

export default class LegalStore {
  private _store: SeekerStore;
  @observable termsText: string;
  @observable privacyText: string;
  @observable showTerms: boolean;
  @observable showPrivacy: boolean;
  @observable acceptTerms: number;
  @observable showDisclaimer: boolean;
  @observable disclaimerText: string;

  constructor(store: SeekerStore) {
    this._store = store;
    this.termsText = null;
    this.privacyText = null;
    this.disclaimerText = null;
    this.showDisclaimer = false;
    this.showTerms = false;
    this.showPrivacy = false;
    this.acceptTerms = 0;
    this._store.languageCallbacks.push(this.clear);
  }

  @action showTermsAndConditions = (): void => {
    if (!this.termsText) {
      Fetcher.get(`api/lookups/seekerterms/${this._store.localization.language}`, action((terms: string): void => {
        this.termsText = terms;
        this.showTerms = true;
      }));
    } else {
      this.showTerms = true;
    }
  }
  @action hideTermsAndConditions = (): void => {
    this.showTerms = false;
  }
  @action setAcceptTerms = (accept: number): void => {
    if (accept !== this.acceptTerms) {
      this.acceptTerms = accept;
      if (accept > 0) {
        Fetcher.post(`/api/account/terms/${accept}`, {}, (): void => { });
      }
    }
  }

  @action showPrivacyStatement = (): void => {
    if (!this.privacyText) {
      Fetcher.get(`api/lookups/seekerprivacy/${this._store.localization.language}`, action((p: string): void => {
        this.privacyText = p;
        this.showPrivacy = true;
      }));
    } else {
      this.showPrivacy = true;
    }
  }

  @action hidePrivacyStatement = (): void => {
    this.showPrivacy = false;
  }

  @action showDisclaimerStatement = (): void => {
    this.disclaimerText = this._store.localization.fields.disclaimerDlg.legal;
    this.showDisclaimer = true;
  }

  @action hideDisclaimer = (): void => {
    this.showDisclaimer = false;
  }

  @action clear = (): void => {
    this.termsText = null;
    this.privacyText = null;
    this.disclaimerText = null;
    this.showTerms = this.showPrivacy = false;
  }
}


// WEBPACK FOOTER //
// ./src/stores/legalStore.ts